<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.6665 10.6693L12.6665 5.33594L14.6665 10.6693C14.0865 11.1026 13.3865 11.3359 12.6665 11.3359C11.9465 11.3359 11.2465 11.1026 10.6665 10.6693Z" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.3335 10.6693L3.3335 5.33594L5.3335 10.6693C4.7535 11.1026 4.0535 11.3359 3.3335 11.3359C2.6135 11.3359 1.9135 11.1026 1.3335 10.6693Z" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.6665 14H11.3332" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 2V14" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2 4.66927H3.33333C4.66667 4.66927 6.66667 4.0026 8 3.33594C9.33333 4.0026 11.3333 4.66927 12.6667 4.66927H14" :stroke="color" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#717680',
    },
  },
};
</script>
